import React from 'react'
import { CustomContextProvider } from '@cvg/react-hooks'

import Aside from './Aside'
import AsyncContent from './AsyncContent'
import Content from './Content'
import Footer from './Footer'
import Header from './Header'
import Main from './Main'
import Nav from './Nav'

const Page = ({ children, context, ...rest }) => {
  if (!context) return <div {...rest}>{children}</div>

  return (
    <CustomContextProvider context={context}>
      <div {...rest}>{children}</div>
    </CustomContextProvider>
  )
}

Page.Aside = Aside
Page.AsyncContent = AsyncContent
Page.Content = Content
Page.Footer = Footer
Page.Header = Header
Page.Main = Main
Page.Nav = Nav

export default Page
